<div class="h-full mx-1 overflow-x-hidden">
    <div class="h-full flex flex-col bg-white rounded-xl pl-4 gap-3">
        <div class="flex flex-row justify-between items-center">
            <app-field-intervention-title
                (deleteFieldIntervention)="fieldInterventionService.openDeleteModal()"
                (editContextLayers)="openEditContextLayersModal()"
                (editFieldInterventionArea)="openFieldInterventionAreaEdition()" />
            <div class="pt-4">
                <app-button
                    [disabled]="!fieldInterventionPermissionService.canManageFieldIntervention()"
                    [icon]="['fas', 'arrow-down-to-line']"
                    [label]="'export' | transloco"
                    [loading]="isExportJobRunning()"
                    [tooltip]="
                        !fieldInterventionPermissionService.canManageFieldIntervention()
                            ? ('insufficientPermissions' | transloco)
                            : undefined
                    "
                    [type]="ButtonType.PRIMARY"
                    (onClick)="openExportModal()" />

                <mat-form-field
                    appearance="outline"
                    class="not-bordered px-4">
                    <mat-select
                        [placeholder]="'allLayers' | transloco"
                        (valueChange)="updateLayer($event)">
                        @for (layer of layerList(); track layer.id) {
                            <mat-option [value]="layer.id">
                                {{ layer.name }}
                            </mat-option>
                        }
                        <mat-option [value]="ALL_LAYERS_SELECTED">
                            {{ 'allLayers' | transloco }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="h-full w-full flex flex-col">
            @if (isError()) {
                <app-no-data-to-display
                    [iconSize]="'5x'"
                    [information]="'noDataFound'" />
            } @else {
                @defer (when !isLoading()) {
                    <div class="flex flex-row justify-between items-start pr-2">
                        <app-field-intervention-information
                            class="w-2/3"
                            [contextLayersSelected]="contextLayersSelected()"
                            [description]="description()"
                            [isFlexRow]="false"
                            [isPlanningDisplay]="false"
                            [showContextLayers]="fieldInterventionPermissionService.canManageFieldIntervention()" />
                        @if (computedStatisticHalfGauge()) {
                            <app-gauge-chart
                                class="w-1/3"
                                [computedStatistic]="computedStatisticHalfGauge()!"
                                [half]="true"
                                [isExpanded]="false"
                                [isStatisticScreen]="false"
                                [isTitleCentred]="true"
                                [tooltipMessage]="'rateEntitiesWithStatus' | transloco"
                                [translateName]="true" />
                        }
                    </div>

                    <div class="flex flex-col mt-6 items-start p-4">
                        <h3 class="dashboard-title pl-4">
                            {{ 'trackingInformation' | transloco }}
                        </h3>
                        <div class="self-start flex flex-row justify-center items-center w-full">
                            @if (entitiesStatistics()) {
                                <app-value-chart
                                    class="w-1/3 cursor-pointer h-full pl-4"
                                    [computedStatistic]="entitiesStatistics()!"
                                    [isDashboardFieldInterventionScreen]="true"
                                    [isExpanded]="true"
                                    [isStatisticScreen]="false"
                                    (click)="openFilteredTable(RoutePathEnum.FIELD_INTERVENTION_ENTITIES)" />
                            }
                            @if (layersStatistics()) {
                                <app-value-chart
                                    class="w-1/3 cursor-pointer h-full px-2"
                                    [computedStatistic]="layersStatistics()!"
                                    [isDashboardFieldInterventionScreen]="true"
                                    [isExpanded]="true"
                                    [isStatisticScreen]="false"
                                    (click)="openFilteredTable(RoutePathEnum.FIELD_INTERVENTION_LAYERS)" />
                            }
                            @if (formsStatistics()) {
                                <app-value-chart
                                    class="w-1/3 cursor-pointer h-full pr-4"
                                    [computedStatistic]="formsStatistics()!"
                                    [isDashboardFieldInterventionScreen]="true"
                                    [isExpanded]="true"
                                    [isStatisticScreen]="false" />
                            }
                        </div>
                    </div>

                    <div class="flex flex-row my-8 p-4">
                        <div class="self-start flex flex-row justify-center w-full h-full items-stretch">
                            <app-field-intervention-operator-or-status-metrics
                                class="w-1/2 cursor-pointer px-2"
                                [fieldInterventionEntities]="fieldInterventionEntities()"
                                [title]="fieldInterventionEntities()!.title" />
                            <app-field-intervention-operator-or-status-metrics
                                class="w-1/2 cursor-pointer pl-4 pr-6"
                                [fieldInterventionOperators]="fieldInterventionOperators()"
                                [title]="fieldInterventionOperators()!.title" />
                        </div>
                    </div>
                } @placeholder {
                    <app-loading class="loading-content" />
                }
            }
        </div>
    </div>
</div>
